import { SET_UI, SET_ERROR, UPDATE_TIMEOUT_MESSAGE, SET_CURRENT_PAGE, SET_APP_STATE } from '../constants/actions'
import { UI } from '../constants/ui'
import { AppState } from '../reducers'
import { getStateFromStore, setStateToStore, clearStateInStore } from './localStorage'
import moment from 'moment-mini'
import _ from 'lodash'
import { getMode } from '../hooks/mode'
import { MODE } from '../constants/mode'
import i18next from 'i18next'

export const getStateFromLocalStorageAction: any = () => async (dispatch: any) => {
  const localStorageState: Pick<AppState, 'reservation' | 'reservationChange' | 'ui' | 'terminal'> & {
    lang: string
  } = getStateFromStore()

  const lang = _.get(localStorageState, 'lang')
  if (lang) {
    await i18next.changeLanguage(lang)
  }

  const dateFrom: number = _.get(localStorageState, 'reservation.originReservation.route.dateFrom')
  if (dateFrom === undefined) {
    return
  }

  const isDataActualForNow = moment().isSameOrBefore(moment(+dateFrom).add(2, 'h'))
  if (isDataActualForNow) {
    dispatch({ type: SET_APP_STATE, payload: localStorageState })
  } else {
    clearStateInStore()
  }
}

const setStateToStoreAction = () => async (dispatch: any, getState: any) => {
  const { ui, reservation, reservationChange, terminal } = getState()
  const lang = i18next.language
  setStateToStore({ ui, reservation, reservationChange, terminal, lang })
}

export const setUIForwardAction: any = (state: UI) => async (dispatch: any, getState: any) => {
  const currentPage = getState().reservation.currentPage
  dispatch({
    type: SET_CURRENT_PAGE,
    payload: +currentPage + 1,
  })
  dispatch({ type: SET_UI, payload: state })

  if (getMode() !== MODE.KIOSK) {
    dispatch(setStateToStoreAction())
  }
}

export const setUIBackwardsAction: any = (state: UI) => async (dispatch: any, getState: any) => {
  const currentPage = getState().reservation.currentPage
  dispatch({
    type: SET_CURRENT_PAGE,
    payload: +currentPage - 1,
  })
  dispatch({ type: SET_UI, payload: state })
    
  if (getMode() !== MODE.KIOSK) {
    dispatch(setStateToStoreAction())
  }
}

export const setErrorAction = (errorTitle: string, error: string, showButton?: boolean) => ({
  type: SET_ERROR,
  payload: { errorTitle, error, showButton },
})
export const setIsShowTimeOutMessageAction = (isShowTimeOutMessage: boolean) => ({
  type: UPDATE_TIMEOUT_MESSAGE,
  payload: isShowTimeOutMessage,
})

export const setUIAction = (state: UI) => ({ type: SET_UI, payload: state })
